import { showToast } from "./utils/toast";

const card = (): HTMLElement | null => document.querySelector<HTMLElement>("[data-bot-goal]");

function csrf(): string {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || "";
}

function setEditing(editing: boolean): void {
  const root = card();
  if (!root) return;
  root.querySelector<HTMLElement>("[data-bot-goal-view]")!.hidden = editing;
  root.querySelector<HTMLElement>("[data-bot-goal-form]")!.hidden = !editing;
  const head = document.querySelector<HTMLElement>("[data-bot-goal-head]");
  if (head) head.hidden = editing || root.querySelector<HTMLElement>("[data-bot-goal-view]")!.dataset.hasGoal !== "true";
  if (editing) {
    updatePlan();
    root.querySelector<HTMLInputElement>("#goal-hires")?.select();
  }
}

function value(input: HTMLInputElement | null, max: number): number {
  const number = Math.round(Number(input?.value));
  return number >= 1 ? Math.min(number, max) : 0;
}

function updatePlan(): void {
  const form = card()?.querySelector<HTMLFormElement>("[data-bot-goal-form]");
  if (!form) return;
  const hires = value(form.querySelector("#goal-hires"), 50);
  const perHire = value(form.querySelector("#goal-per-hire"), 30);
  const planned = hires * perHire;
  form.querySelector<HTMLElement>("[data-bot-goal-eq]")!.innerHTML = planned
    ? `= <b>${planned} ${planned === 1 ? "interview" : "interviews"}</b> planned`
    : "Enter numbers above 0";
  form.querySelector<HTMLButtonElement>("[data-bot-goal-save]")!.disabled = !planned;
}

async function patch(url: string, field: string, value: string): Promise<boolean> {
  const response = await fetch(url, {
    method: "PATCH",
    headers: { "X-CSRF-Token": csrf(), Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify({ field, value }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) showToast(data.message || "Couldn't save the goal", "error");
  return response.ok;
}

async function save(fields: [string, string][], message: string): Promise<void> {
  const root = card();
  const form = root?.querySelector<HTMLFormElement>("[data-bot-goal-form]");
  if (!root || !form) return;
  for (const [field, val] of fields) {
    if (!(await patch(form.dataset.url!, field, val))) return;
  }
  const response = await fetch(form.dataset.reloadUrl!, { headers: { Accept: "text/html" } });
  if (response.ok) root.innerHTML = await response.text();
  setEditing(false);
  showToast(message);
}

function handleClick(event: Event): void {
  const target = event.target as HTMLElement;
  if (!card()) return;
  if (target.closest("[data-bot-goal-edit]")) return setEditing(true);
  if (target.closest("[data-bot-goal-cancel]")) return setEditing(false);
  if (target.closest("[data-bot-goal-remove]")) void save([["hires_target", ""]], "Goal removed");
}

let bound = false;

export function initBotGoal(): void {
  if (bound) return;
  bound = true;

  document.addEventListener("click", handleClick);
  document.addEventListener("input", (event) => {
    if ((event.target as HTMLElement).closest("[data-bot-goal-form]")) updatePlan();
  });
  document.addEventListener("submit", (event) => {
    const form = (event.target as HTMLElement).closest<HTMLFormElement>("[data-bot-goal-form]");
    if (!form) return;
    event.preventDefault();
    const hires = String(value(form.querySelector("#goal-hires"), 50));
    const perHire = String(value(form.querySelector("#goal-per-hire"), 30));
    void save([["interviews_per_hire", perHire], ["hires_target", hires]], "Goal saved");
  });
}
